import { render } from "./Backlog.vue?vue&type=template&id=12f7af56"
import script from "./Backlog.vue?vue&type=script&lang=js"
export * from "./Backlog.vue?vue&type=script&lang=js"

import "./Backlog.vue?vue&type=style&index=0&id=12f7af56&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__